import { useState, type ReactNode } from 'react';
import Modal from '../Modal';
import Button from '../../buttons/Button';
import TextAreaField from '../../dataEntry/TextAreaField';

/**
 * Confirmação de ação irreversível. Com `reasonLabel`, exige um motivo (ex.: reprovação na fila — RN-97).
 */
export default function ConfirmDialog({ open, onClose, onConfirm, title, children, confirmLabel = 'Confirmar', danger, reasonLabel, loading }: {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason?: string) => void;
  title: string;
  children?: ReactNode;
  confirmLabel?: string;
  danger?: boolean;
  reasonLabel?: string;
  loading?: boolean;
}) {
  const [reason, setReason] = useState('');
  const needsReason = !!reasonLabel;
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      footer={<>
        <Button variant="ghost" onClick={onClose}>Cancelar</Button>
        <Button variant={danger ? 'danger' : 'primary'} loading={loading} disabled={needsReason && reason.trim().length < 5} onClick={() => onConfirm(needsReason ? reason.trim() : undefined)}>{confirmLabel}</Button>
      </>}
    >
      <div className="stack">
        {children}
        {needsReason && <TextAreaField label={reasonLabel} value={reason} onChange={(e) => setReason(e.target.value)} hint="Mínimo de 5 caracteres." autoFocus />}
      </div>
    </Modal>
  );
}
